/**
 * When `NEXT_PUBLIC_INVITE_ONLY=true`, the app shows invite-only admin UX:
 * no self-serve signup, no Google OAuth on login/signup, marketing CTAs use "Request access".
 * Pair with Supabase Auth: disable public signups and (for strict control) disable Google OAuth.
 */
export function isInviteOnly(): boolean {
  return process.env.NEXT_PUBLIC_INVITE_ONLY === 'true';
}

/** Primary nav / hero CTA when invite-only vs open signup. */
export function signUpCtaLabel(): string {
  return isInviteOnly() ? 'Request access' : 'Sign up';
}

/** Hero primary button label. */
export function heroPrimaryCtaLabel(): string {
  return isInviteOnly() ? 'Request access' : 'Get started';
}

export function featuresBottomCtaLabel(): string {
  return isInviteOnly() ? 'Request access' : 'Start building your first project';
}

export function howItWorksBottomCtaLabel(): string {
  return isInviteOnly() ? 'Request access' : 'Get started';
}

export function finalCtaHeadlineSubtext(): string {
  return isInviteOnly()
    ? 'Access is by invitation. Sign in if you already have an account.'
    : 'Create your account and sync prop screens across devices on set.';
}

export function finalCtaButtonLabel(): string {
  return isInviteOnly() ? 'Request access' : 'Create account';
}

/** Mobile bottom pill. */
export function mobileFloatingSignupLabel(): string {
  return isInviteOnly() ? 'Request access' : 'Sign up';
}
